import * as React from 'react';
import { Label } from 'reactstrap';
import './filter.css';

export interface ISortBoxProps {
  onSort: (text: string) => void,
  options: any;
  selected?: string;
  label?: string;
  disabled?: boolean;
};

export class SortBox extends React.Component<ISortBoxProps, any> {
  public static defaultProps: Partial<ISortBoxProps> = {
		label: 'Sort by'
  }
  constructor(props) {
		super(props);
	}
  public handleOnChange = (newText: string) => {
    this.props.onSort(newText);
  }

  public render() {
    return (
      <div className="filter-container">
        <Label>{this.props.label}</Label>
        <form>
          <div className="pt-input-group">
            <select
              className="filter-input"
              dir="auto"
              onChange={(event) => this.handleOnChange(event.target.value)}
              disabled={this.props.disabled}
            >
              {this.getCustomOptions(this.props.options)}
            </select>
          </div>
        </form>
      </div>
    )
  }

  public getCustomOptions = (options: any) => {
    const keys = Object.keys(options)
    return keys.map(key => <option key={key} value={key} selected={this.props.selected === key}>{options[key]}</option>)
  }
}

export default SortBox;